import styled from "styled-components";

export const BottomNav = styled.div`
  width: 100%;
`;

export const BottomNavList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  a {
    width: 100%;
    padding: 6px;
  }
`;

export const BottomItemNavBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
